import { render, staticRenderFns } from "./line-items-dialog-comp.vue?vue&type=template&id=af7f6c4a&scoped=true&"
import script from "./line-items-dialog-comp.vue?vue&type=script&lang=js&"
export * from "./line-items-dialog-comp.vue?vue&type=script&lang=js&"
import style0 from "./line-items-dialog-comp.vue?vue&type=style&index=0&id=af7f6c4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7f6c4a",
  null
  
)

export default component.exports